<template>
    <div class="order_search_box">
        <!-- 标签页 -->
        <el-tabs 
            :value="order_tabs"
             @tab-click="tabClick">
            <el-tab-pane
                v-for="(item, index) in tabs"
                :key="index"
                :label="item.label"
                :name="item.name">
            </el-tab-pane>
        </el-tabs>
        <!-- 订单号 -->
        <el-row :gutter="10">
            <!-- 标题 -->
            <el-col :span="4">
                <div class="order_search_title">{{$t("message.corder.search1")}}</div>
            </el-col>
            <!-- 搜索框 -->
            <el-col :span="10">
                <el-input
                    size="small"
                    :placeholder="$t('message.corder.place1')"
                    v-model="order_sn"
                    @change="orderSnChange">
                </el-input>
            </el-col>
            <!-- 条件选择开关 -->
            <el-col :span="4">
                <el-button
                    size="mini"
                    type="text"
                    @click="more_search? more_search=false : more_search=true">
                    <span>{{$t("message.corder.search2")}}</span>
                    <i class="el-icon-arrow-up" v-show="more_search"></i>
                    <i class="el-icon-arrow-down" v-show="!more_search"></i>
                </el-button>
            </el-col>
        </el-row>
        <!-- 更多筛选条件 -->
        <div v-show="more_search">
            <!-- 日期 -->
            <el-row :gutter="10">
                <!-- 开始日期 -->
                <el-col :span="4">
                    <div class="order_search_title">{{$t("message.corder.search3")}}</div>
                </el-col>
                <el-col :lg="5" :md="7">
                    <el-date-picker
                        v-model="start_date"
                        type="date"
                        size="small"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="startChange"
                        :placeholder="$t('message.corder.place2')"
                        class="order_search_data_picker">
                    </el-date-picker>
                </el-col>
                <!-- 结束日期 -->
                <el-col :span="4">
                    <div class="order_search_title">{{$t("message.corder.search4")}}</div>
                </el-col>
                <el-col :lg="5" :md="7">
                    <el-date-picker
                        v-model="end_date"
                        type="date"
                        size="small"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        @change="endChange"
                        :placeholder="$t('message.corder.place3')"
                        class="order_search_data_picker">
                    </el-date-picker>
                </el-col>
            </el-row>
            <!-- 部门 & 人员 -->
            <el-row :gutter="10"
                v-if="!power.includes(111)">
                <!-- 部门选择 -->
                <el-col :span="4">
                    <div class="order_search_title">{{$t("message.corder.search5")}}</div>
                </el-col>
                <el-col :lg="5" :md="7">
                    <el-select
                        v-model="department"
                        size="small"
                        clearable
                        @change="selectDepartment"
                        :placeholder="$t('message.corder.place4')">
                        <el-option
                            v-for="(item, index) in order_department"
                            :key="index"
                            :label="item.departmentname"
                            :value="item.department_id">
                            <!-- 部门名称 -->
                            <span class="order_search_departmentname">{{item.departmentname}}</span>
                            <!-- 公司名称 -->
                            <span class="order_search_branchname">{{item.branchname}}</span>
                        </el-option>
                    </el-select>
                </el-col>
                <!-- 下单员选择 -->
                <el-col :span='4' v-if="member_list.length>0">
                    <div class="order_search_title">{{$t("message.corder.search6")}}</div>
                </el-col>
                <el-col :lg="5" :md="7" v-if="member_list.length>0">
                    <el-select 
                        v-model="member"
                        :placeholder="$t('message.corder.place5')"
                        clearable
                        @change="selectMember"
                        size="small">
                        <el-option
                            v-for="item in member_list"
                            :key="item.id"
                            :label="item.username"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
        </div>
        <!-- 搜索按钮 -->
        <el-row>
            <el-col :offset="4">
                <el-button
                    size="mini"
                    type="primary"
                    @click="handleSearch">
                    <span>{{$t("public.searchBtn")}}</span>
                </el-button>
                <el-button
                    size="mini"
                    type="primary"
                    @click="handleExport">
                    <span>{{$t("message.corder.excel")}}</span>
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    data() {
        let order_sn = sessionStorage.getItem("order_sn") || "",
        release = sessionStorage.getItem("release") || "",
        relend = sessionStorage.getItem("relend") || "",
        department = Number(sessionStorage.getItem("department")) || "",
        user_id = Number(sessionStorage.getItem("member")) || "";
        return {
            order_sn: order_sn, // 订单号
            more_search: !!release || !!relend || !!department || !!user_id, // 更多筛选条件

            start_date: release, // 开始日期
            end_date: relend, // 结束日期
            pickerOptions:{ // 结束日期限定选择区
                disabledDate:(time)=>{
                    return time.getTime() < new Date(this.start_date).getTime();
                }
            },

            department: department, // 部门
            member: user_id, // 部门成员
            member_list: [], // 成员列表
        }
    },
    props: {
        tabs: Array,
        handleDownload: {
            type: Function,
            default: () => {}
        },
		handle:String
    },
    computed: mapState({
        order_tabs: state => state.order.order_tabs,
        order_department: state => state.user.order_department,
        power: state => state.user.power
    }),
    methods: {
        ...mapMutations([
            "setOrderTabs"
        ]),
        tabClick(tab, event){ // 标签页更改
            this.setOrderTabs(tab.name);
            sessionStorage.setItem("order_tabs", tab.name);
            this.handleSearch();
        },
        orderSnChange(val){ // 写入order_sn
            sessionStorage.setItem("order_sn",val)
        },
        startChange(val){ // 起始日期改变时
            sessionStorage.setItem("release", val);
            if(val == null){
                sessionStorage.removeItem("release")
            }
            if(this.end_date<this.start_date){
                this.end_date=""
            }
        },
        endChange(val){ // 结束日期改变时
            sessionStorage.setItem("relend", val)
            if(val == null){
                sessionStorage.removeItem("relend")
            }
        },
        selectDepartment(val){ // 选择部门发生变化时
            sessionStorage.setItem("department", val);
            this.member = "";
            if(val){
                for(let item of this.order_department){
                    if(item.department_id == val){
                        this.member_list = item.user;
                    }
                }
            }else{
                this.member_list = [];
            }
        },
        selectMember(val){ // 选择人员发生改变时
            sessionStorage.setItem("member", val)
        },
        handleSearch(){ // 获取订单列表
            this.$emit('handle-search');
        },
		
        handleExport(){ // 导出Excel
			 this.$emit('handle-export')
			// let end_date =  this.end_date==null?'':this.end_date;
			// let start_date =  this.start_date==null?'':this.start_date;
			// let hert = this.$URL.baseUrl + this.handle + '?order_sn='+ this.order_sn + '&release=' +  start_date + '&relend=' + end_date + '&department=' + this.department  + '&user_id=' +  this.member + '&lang=cn'
			// window.location.href = hert
			
			
			
            // let data = {
            //     order_sn: this.order_sn,
            //     release: this.start_date,
            //     relend: this.end_date,
            //     department: this.department,
            //     user_id: this.member,
            // }
            // this.handleDownload(data).then((res) => {
            //     const blob = res;
            //     const reader = new FileReader();
            //     reader.readAsDataURL(blob);
            //     reader.onload = (e) => {
            //         let date = new Date(),
            //         y = date.getFullYear(),
            //         m = date.getMonth() + 1,
            //         d = date.getDate();
            //         m = m < 10 ? ('0' + m) : m;
            //         d = d < 10 ? ('0' + d) : d;
            //         const a = document.createElement('a');
            //         a.download = y + m + d + ".xls";
            //         a.href = e.target.result;
            //         document.body.appendChild(a);
            //         a.click();
            //         document.body.removeChild(a);
            //     };
            // })
        }
    },
}
</script>

<style scoped>
/* 组件盒子 */
.order_search_box{
    padding: 20px;
    background: #fff;
}
.order_search_box .el-row{
    margin-bottom: 15px;
}
/* 订单搜索标题 */
.order_search_title{
    padding: 7px 0;
    text-align: right;
}

/* 日期选择器 */
.order_search_data_picker{
    width: 100%;
}
/* 选择部门下拉框-部门名称 */
.order_search_departmentname{
    float: left;
    max-width: 100px;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    color: #303133;
}
/* 选择部门下拉框-公司名称 */
.order_search_branchname{
    float: right;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #C0C4CC;
    font-size: 13px;
}
</style>
